import { SelectOption } from '@globaleris/ui.library'
import { updatedDiff } from 'deep-object-diff'
import moment from 'moment'
import {
  CicloFacturacion,
  EnumPrecioUnitario,
  EnumTipoOperacion,
  EnumTipoPosicion,
  EnumTipoSujeto,
  EnumUnidadMedida,
  EnumZonaBalance,
  PositionType,
  ValidationType
} from '../../api'
import { EnumPriceCalculationType, EnumRedondeo } from '../../api/Argentia/enums'
import { EnumTipoMetodoPago } from '../../api/oData/enums/enumTipoMetodoPago'
import { EnumTipoValidacion } from '../../api/oData/enums/enumTipoValidacion'
import { EnumNivelCicloFacturacion } from '../../api/Pioneer/enums/nivelCicloFacturacion'
import { UnitMeasure } from '../../api/Pioneer/enums/unitMeasure'
import { Currency } from '../../api/Pioneer/model/Currency'
import { MeasureUnit } from '../../api/Pioneer/model/MeasureUnit'
import {
  AddTradeAPIRequest,
  AddTradeRequest,
  Broker,
  AddComplexTradeRequest,
  FetchRequest,
  LogisticElementBase,
  NewPosicionPrecio,
  NewPrecioPosicion,
  NewPricePosition,
  PatchTradePioneerRequest,
  PosicionDelta,
  PosicionPrecio,
  PrecioPosicionRequest,
  PricePosition,
  TradeAditionalsDetails,
  TradeDetailsRequest,
  TradeDetailsResponse,
  TradeListItem,
  TradeMainDetails,
  TradePriceRequest,
  TradePricingDetails,
  Tramo,
  TramosDelta,
  PositionMainDetails,
  PosicionPrecioDiff,
  PositionPrice,
  TramosModelPatchPioneerRequest,
  PositionPriceAPIRequest,
  Tract,
  TractAPIRequest,
  EnumCurrency
} from '../../api/Pioneer/model/trades'
import {
  enumEnumToValueNumber,
  enumEnumToValueString,
  enumKeyToValue,
  enumToSelectOptionArrayDefaultValues,
  enumValueToKey,
  getUniqueArray,
  getUniqueArrayByProperty,
  isEmpty
} from '../../helpers'
import i18n from '../../i18n'
import {
  BalanceZoneStoreModel,
  getActiveBalanceZone,
  getActiveCompany,
  getActiveTrade,
  getBalanceZonesForCompany
} from '../../redux'
import { getNewPriceDates } from './helpers/trades.helper'
import { FetchTradesRequest, TradeListItemViewModel } from './trades.model'
import { differenceBy } from '../../helpers/objectHelper/objectHelper'
import { TRADES_TABS } from './trades'
import { AddMassiveBuyAndSellModel } from '../buyandsell/buyandsell.model'
import { EnumTipoTrade } from '../../api/oData/enums/enumTipoTrade'

export const mapTradesFetchRequest = (request: FetchTradesRequest): FetchRequest => {
  const balanceZones = getBalanceZonesForCompany()

  return {
    initDate: request.initDate,
    endDate: request.endDate,
    company: getActiveCompany()?.id!,
    balanceZone: balanceZones && balanceZones.length > 1 ? getActiveBalanceZone()?.id! : undefined,
    counterpart: request.counterpart,
    deliveryPoint: request.deliveryPoint,
    subjectType:
      request.tab === TRADES_TABS.EXTENDED_CLIENT
        ? EnumTipoSujeto.ClienteExtendido
        : request.tab === TRADES_TABS.GENERAL
          ? EnumTipoSujeto.Mayorista
          : undefined
  }
}

export const mapTradeListItemsViewModel = (items: TradeListItem[]): TradeListItemViewModel[] => {
  return items && items.map(mapTradeListItemViewModel)
}

export const mapTradeListItemViewModel = (item: TradeListItem): TradeListItemViewModel => {
  return {
    ...item,
    canEdit: true,
    candDelete: true,
    deliveryPointsIds: item.deliveryPoints
      ? item.deliveryPoints.length > 1
        ? [9999]
        : getUniqueArray(item.deliveryPoints?.map(x => x.id))
      : [],
    tradeType: enumValueToKey(EnumTipoPosicion, item.positionType)
  }
}

export const mapStateToFormData = (state: Partial<AddTradeRequest>): AddTradeRequest | null => {
  return state &&
    state.balanceZone &&
    state.counterpart &&
    state.currency &&
    state.dailyQuantity &&
    state.dailyQuantityUnit &&
    state.deliveryPoint &&
    state.initDate &&
    state.endDate &&
    state.type &&
    state.signDate &&
    state.totalQuantity &&
    state.state
    ? {
        balanceZone: state.balanceZone,
        company: state.company ?? 0,
        counterpart: state.counterpart,
        currency: state.currency,
        dailyQuantity: state.dailyQuantity,
        dailyQuantityUnit: state.dailyQuantityUnit,
        deliveryPoint: state.deliveryPoint,
        description: state.description ?? '',
        endDate: state.endDate,
        fee: state.fee ?? 0,
        initDate: state.initDate,
        signDate: state.signDate,
        state: state.state,
        totalQuantity: state.totalQuantity,
        type: state.type
      }
    : null
}

export const mapStateToCreateComplexTradeRequest = (
  state: Partial<TradeMainDetails>,
  companyId: number
): AddComplexTradeRequest | null => {
  return state &&
    state.currency &&
    state.counterpart &&
    state.initDate &&
    state.endDate &&
    state.signDate &&
    state.state
    ? {
        balanceZone: state.balanceZone,
        company: companyId,
        counterpart: state.counterpart,
        currency: state.currency,
        description: state.description ?? '',
        endDate: state.endDate,
        initDate: state.initDate,
        signDate: state.signDate,
        state: state.state
      }
    : null
}

export const mapStateToCreateRequest = (
  state: Partial<TradeMainDetails>,
  companyId: number
): AddTradeRequest | null => {
  return state &&
    state.balanceZone &&
    state.counterpart &&
    state.currency &&
    state.dailyQuantity &&
    state.dailyQuantityUnit &&
    state.deliveryPoint &&
    state.initDate &&
    state.endDate &&
    state.type &&
    state.signDate &&
    state.state
    ? {
        balanceZone: state.balanceZone,
        company: companyId,
        counterpart: state.counterpart,
        currency: state.currency,
        dailyQuantity: state.dailyQuantity,
        dailyQuantityUnit: enumKeyToValue(UnitMeasure, state.dailyQuantityUnit),
        deliveryPoint: state.deliveryPoint,
        description: state.description ?? '',
        endDate: state.endDate,
        fee: state.fee ?? 0,
        initDate: state.initDate,
        signDate: state.signDate,
        state: state.state,
        type: state.type
      }
    : null
}

export const mapAditionalsToCreateRequest = (
  aditionals: Partial<TradeAditionalsDetails>
): Partial<AddTradeRequest> => {
  return {
    category: aditionals.category ?? undefined,
    book: aditionals.book ?? undefined,
    contract: aditionals.contract ?? undefined,
    paymentMethod: aditionals.paymentMethod
      ? enumEnumToValueNumber(EnumTipoMetodoPago, aditionals.paymentMethod)
      : undefined,
    billingCycle: aditionals.billingCycleId ?? undefined,
    billingLevel: aditionals.billingLevel ?? undefined,
    comments: aditionals.comments ?? undefined
  }
}

export const mapPositionAddTradeRequest = (positions): PositionPrice[] => {
  const formatPositions: any = []
  positions.forEach(pos => {
    const positionPrice =
      pos.price &&
      pos.price.expression &&
      pos.price.priceUnit &&
      pos.price.priceCalculationType &&
      pos.price.rounding
        ? {
            expression: pos.price.expression,
            priceUnit: enumEnumToValueString(EnumPrecioUnitario, pos.price.priceUnit),
            priceCalculationType: enumEnumToValueString(
              EnumPriceCalculationType,
              pos.price.priceCalculationType
            ),
            rounding: enumEnumToValueString(EnumRedondeo, pos.price.rounding),
            version: 1
          }
        : undefined
    formatPositions.push({
      description: pos.descripcion,
      positionType: pos.tipoPosicion,
      measureUnit: enumKeyToValue(EnumUnidadMedida, pos.unidadMedida),
      deliveryPointId: pos.puntoEntrega.id,
      balanceZone: pos.zonaBalance,
      startDate: pos.fechaInicio,
      endDate: pos.fechaFin,
      price: positionPrice,
      tracts:
        pos.tramos.length > 0
          ? mapPositionTractsAddTradeRequest(pos.tramos)
          : [
              {
                startDate: pos.fechaInicio,
                endDate: pos.fechaFin,
                dailyQuantity: pos.cantidadDiaria,
                fee: pos.fee
              }
            ]
    })
  })
  return formatPositions
}

export const mapPositionTractsAddTradeRequest = tracts => {
  const formatTracts: any = []
  tracts.forEach(tract => {
    formatTracts.push({
      startDate: tract.fechaInicio,
      endDate: tract.fechaFin,
      dailyQuantity: tract.cantidadDiaria,
      fee: tract.fee
    })
  })
  return formatTracts
}

export const mapPositionsPriceToAPIRequest = (
  positions: PositionPrice[]
): PositionPriceAPIRequest[] => {
  return positions.map(position => mapPositionPriceToAPIRequest(position))
}

export const mapPositionPriceToAPIRequest = (position: PositionPrice): PositionPriceAPIRequest => {
  return {
    ...position,
    startDate: moment(position.startDate).format('YYYY-MM-DD'),
    endDate: moment(position.endDate).format('YYYY-MM-DD'),
    tracts: mapTractsToAPIRequest(position.tracts)
  }
}

export const mapTractsToAPIRequest = (tracts: Partial<Tract>[]): TractAPIRequest[] => {
  return tracts.map(tract => mapTractToAPIRequest(tract))
}

export const mapTractToAPIRequest = (tract: Partial<Tract>): TractAPIRequest => {
  return {
    ...tract,
    startDate: moment(tract.startDate).format('YYYY-MM-DD'),
    endDate: moment(tract.endDate).format('YYYY-MM-DD')
  }
}

export const mapAddComplexTradeRequest = (
  trade: AddTradeRequest,
  brokers: Broker[],
  tradeAditionals: Partial<AddTradeRequest> | undefined,
  companyId: number
): AddTradeAPIRequest => {
  return (
    trade && {
      description: trade.description,
      currency: trade.currency,
      initDate: moment(trade.initDate).format('YYYY-MM-DD'),
      endDate: moment(trade.endDate).format('YYYY-MM-DD'),
      signDate: moment(trade.signDate).format('YYYY-MM-DD'),
      state: trade.state,
      company: companyId,
      counterpart: trade.counterpart,
      commodity: 1,
      book: tradeAditionals?.book,
      category: tradeAditionals?.category,
      comments: tradeAditionals?.comments,
      contract: tradeAditionals?.contract,
      billingLevel: tradeAditionals?.billingLevel,
      billingCycle: tradeAditionals?.billingCycle,
      paymentMethod: tradeAditionals?.paymentMethod,
      brokers,
      positions:
        trade.positions && trade.positions.length > 0
          ? mapPositionsPriceToAPIRequest(trade.positions)
          : []
    }
  )
}

export const mapAddTradeRequest = (
  trade: AddTradeRequest,
  brokers: Broker[],
  tradeAditionals: Partial<AddTradeRequest> | undefined,
  companyId: number,
  expression?: string,
  priceUnit?: EnumPrecioUnitario,
  priceCalculationType?: EnumPriceCalculationType,
  rounding?: EnumRedondeo
): AddTradeAPIRequest => {
  return (
    trade && {
      description: trade.description,
      currency: trade.currency,
      initDate: moment(trade.initDate).format('YYYY-MM-DD'),
      endDate: moment(trade.endDate).format('YYYY-MM-DD'),
      signDate: moment(trade.signDate).format('YYYY-MM-DD'),
      state: trade.state,
      company: companyId,
      counterpart: trade.counterpart,
      commodity: 1,
      book: tradeAditionals?.book,
      category: tradeAditionals?.category,
      comments: tradeAditionals?.comments,
      contract: tradeAditionals?.contract,
      billingLevel: tradeAditionals?.billingLevel,
      billingCycle: tradeAditionals?.billingCycle,
      paymentMethod: tradeAditionals?.paymentMethod,
      brokers,
      positions: [
        {
          positionType: enumKeyToValue(EnumTipoPosicion, trade.type),
          measureUnit: enumKeyToValue(EnumUnidadMedida, trade.dailyQuantityUnit),
          deliveryPointId: trade.deliveryPoint,
          balanceZone: trade.balanceZone,
          startDate: moment(trade.initDate).format('YYYY-MM-DD'),
          endDate: moment(trade.endDate).format('YYYY-MM-DD'),
          price:
            expression && priceUnit && priceCalculationType && rounding
              ? {
                  expression: expression,
                  priceUnit: priceUnit,
                  priceCalculationType: priceCalculationType,
                  rounding: rounding,
                  version: 1
                }
              : undefined,
          tracts: [
            {
              startDate: moment(trade.initDate).format('YYYY-MM-DD'),
              endDate: moment(trade.endDate).format('YYYY-MM-DD'),
              dailyQuantity: trade.dailyQuantity,
              fee: trade.fee
            }
          ]
        }
      ]
    }
  )
}

export const formatTradeResponse = (trade: TradeDetailsResponse): TradeDetailsResponse => {
  const positionsList = trade.positions.map(p => {
    return {
      ...p,
      descripcion: p.descripcion ?? '',
      cantidadTotal: undefined
    }
  })
  const conceptID =
    trade.positions && trade.positions.length > 0 && trade.positions[0]?.idConcepto
      ? trade.positions[0]?.idConcepto
      : undefined
  return (
    trade && {
      ...trade,
      conceptId: conceptID,
      positions: positionsList
    }
  )
}

export const mapTradeSimpleResponseToForms = (
  trade: TradeDetailsResponse
): [TradeMainDetails, TradePricingDetails, TradeAditionalsDetails] => {
  const tradeMainDetails: TradeMainDetails = {
    id: trade.tradeId,
    code: trade.code,
    type: trade?.type ? enumValueToKey(EnumTipoPosicion, trade?.type) : undefined,
    currency: trade?.currency ? trade.currency : undefined,
    description: trade.description,
    initDate: trade.initDate,
    endDate: trade.endDate,
    signDate: trade?.signDate,
    state: trade?.state ? enumEnumToValueNumber(EnumTipoValidacion, trade.state) : undefined,
    counterpart: trade?.counterpartId,

    // Position props
    positionId:
      trade?.positions && trade?.positions.length > 0 ? trade?.positions[0]?.idPosicion : undefined,
    positionCode:
      trade?.positions && trade?.positions.length > 0 ? trade?.positions[0]?.codPosicion : '',
    balanceZone: trade?.positions[0]?.zonaBalance
      ? enumValueToKey(EnumZonaBalance, trade?.positions[0].zonaBalance)
      : undefined,
    deliveryPoint:
      trade?.positions && trade?.positions.length > 0
        ? trade?.positions[0]?.puntoEntrega?.id
        : undefined,
    totalQuantity:
      trade?.positions && trade?.positions.length > 0
        ? trade?.positions[0]?.cantidadTotal
        : undefined,
    dailyQuantityUnit:
      trade?.positions && trade?.positions.length > 0 && trade?.positions[0]?.unidadMedida
        ? enumValueToKey(UnitMeasure, trade?.positions[0]?.unidadMedida)
        : undefined,

    // Tract props
    tractId:
      trade?.positions &&
      trade?.positions.length > 0 &&
      trade?.positions[0] &&
      trade?.positions[0].tramos &&
      trade?.positions[0].tramos.length > 0
        ? trade?.positions[0].tramos[0]?.idTramo
        : undefined,
    dailyQuantity:
      trade?.positions &&
      trade?.positions.length > 0 &&
      trade?.positions[0] &&
      trade?.positions[0].tramos &&
      trade?.positions[0].tramos.length > 0
        ? trade?.positions[0].tramos[0]?.cantidadDiaria
        : undefined,
    fee:
      trade?.positions &&
      trade?.positions.length > 0 &&
      trade?.positions[0] &&
      trade?.positions[0].tramos &&
      trade?.positions[0].tramos.length > 0
        ? trade?.positions[0].tramos[0]?.fee
        : undefined
  }

  const tradePricingDetails: TradePricingDetails = {
    id: trade.positions ? trade.positions[0].price?.id : undefined,
    expression: trade?.positions ? trade?.positions[0].price?.expression : undefined,
    priceCalculationType: trade?.positions
      ? trade?.positions[0].price?.priceCalculationType
      : undefined,
    rounding: trade?.positions ? trade.positions[0].price?.rounding : undefined,
    version: trade?.positions ? trade.positions[0].price?.version : undefined,
    currencyAndUnit: trade?.positions ? trade.positions[0].price?.priceUnit : undefined,
    conceptId: trade?.positions ? trade.positions[0].idConcepto : undefined,
    priceConceptId: trade?.positions ? trade.positions[0].idConceptoPrecio : undefined
  }

  const tradeAditionalsDetails: TradeAditionalsDetails = {
    category: trade?.categoryId ? trade?.categoryId : null,
    contract: trade?.contractId ? trade?.contractId : null,
    paymentMethod: trade?.paymentMethodType
      ? enumEnumToValueNumber(EnumTipoMetodoPago, trade?.paymentMethodType)
      : null,
    billingCycleId: trade?.billingCycleId ? trade?.billingCycleId : null,
    billingLevel: trade?.billingLevel
      ? enumValueToKey(EnumNivelCicloFacturacion, trade?.billingLevel)
      : null,
    book: trade?.book ? trade?.book : null,
    brokers: trade?.brokers ? trade.brokers : null,
    comments: trade?.comments ? trade?.comments : null
  }

  return [tradeMainDetails, tradePricingDetails, tradeAditionalsDetails]
}

export const mapTradeResponseToForms = (
  trade: TradeDetailsResponse
): [TradeMainDetails, TradePricingDetails, TradeAditionalsDetails] => {
  const tradeMainDetails: TradeMainDetails = {
    id: trade.tradeId,
    code: trade.code,
    type: trade?.type ? enumValueToKey(EnumTipoPosicion, trade?.type) : undefined,
    currency: trade?.currency ? trade.currency : undefined,
    description: trade.description,
    initDate: trade.initDate,
    endDate: trade.endDate,
    signDate: trade?.signDate,
    state: trade?.state ? enumValueToKey(EnumTipoValidacion, trade.state) : undefined,
    counterpart: trade?.counterpartId,

    // Position props
    positionId:
      trade?.positions && trade?.positions.length > 0 ? trade?.positions[0]?.idPosicion : undefined,
    positionCode:
      trade?.positions && trade?.positions.length > 0 ? trade?.positions[0]?.codPosicion : '',
    balanceZone: trade?.positions[0]?.zonaBalance
      ? enumValueToKey(EnumZonaBalance, trade?.positions[0].zonaBalance)
      : undefined,
    deliveryPoint:
      trade?.positions && trade?.positions.length > 0
        ? trade?.positions[0]?.puntoEntrega?.id
        : undefined,
    totalQuantity:
      trade?.positions && trade?.positions.length > 0
        ? trade?.positions[0]?.cantidadTotal
        : undefined,
    dailyQuantityUnit:
      trade?.positions && trade?.positions.length > 0 && trade?.positions[0]?.unidadMedida
        ? enumValueToKey(UnitMeasure, trade?.positions[0]?.unidadMedida)
        : undefined,

    // Tract props
    tractId:
      trade?.positions &&
      trade?.positions.length > 0 &&
      trade?.positions[0] &&
      trade?.positions[0].tramos &&
      trade?.positions[0].tramos.length > 0
        ? trade?.positions[0].tramos[0]?.idTramo
        : undefined,
    dailyQuantity:
      trade?.positions &&
      trade?.positions.length > 0 &&
      trade?.positions[0] &&
      trade?.positions[0].tramos &&
      trade?.positions[0].tramos.length > 0
        ? trade?.positions[0].tramos[0]?.cantidadDiaria
        : undefined,
    fee:
      trade?.positions &&
      trade?.positions.length > 0 &&
      trade?.positions[0] &&
      trade?.positions[0].tramos &&
      trade?.positions[0].tramos.length > 0
        ? trade?.positions[0].tramos[0]?.fee
        : undefined
  }

  const tradePricingDetails: TradePricingDetails = {
    id: trade.positions ? trade.positions[0].price?.id : undefined,
    expression: trade?.positions ? trade?.positions[0].price?.expression : undefined,
    priceCalculationType: trade?.positions
      ? trade?.positions[0].price?.priceCalculationType
      : undefined,
    rounding: trade?.positions ? trade.positions[0].price?.rounding : undefined,
    version: trade?.positions ? trade.positions[0].price?.version : undefined,
    currencyAndUnit: trade?.positions ? trade.positions[0].price?.priceUnit : undefined,
    conceptId: trade?.positions ? trade.positions[0].idConcepto : undefined,
    priceConceptId: trade?.positions ? trade.positions[0].idConceptoPrecio : undefined
  }

  const tradeAditionalsDetails: TradeAditionalsDetails = {
    category: trade?.categoryId ? trade?.categoryId : null,
    contract: trade?.contractId ? trade?.contractId : null,
    paymentMethod: trade?.paymentMethodType
      ? enumValueToKey(EnumTipoMetodoPago, trade?.paymentMethodType)
      : null,
    billingCycleId: trade?.billingCycleId ? trade?.billingCycleId : null,
    billingLevel: trade?.billingLevel
      ? enumValueToKey(EnumNivelCicloFacturacion, trade?.billingLevel)
      : null,
    book: trade?.book ? trade?.book : null,
    brokers: trade?.brokers ? trade.brokers : null,
    comments: trade?.comments ? trade?.comments : null
  }

  return [tradeMainDetails, tradePricingDetails, tradeAditionalsDetails]
}

const mapPositionToPosicionDelta = (position: Partial<PosicionPrecio>): Partial<PosicionDelta> => {
  const pos: Partial<PosicionDelta> = {
    id: position.idPosicion,
    codPosicion: position.codPosicion,
    fechaInicio: position.fechaInicio,
    fechaFin: position.fechaFin,
    cantidadTotal: position.cantidadTotal,
    tipoPosicion: position.tipoPosicion,
    unidadMedida: position.unidadMedida,
    puntoEntregaDelta: position.deliveryPoint ? { id: position.deliveryPoint.id } : undefined,
    tramosDelta: position.tramos,
    price: position.price
  }

  return pos
}

export const mapFormsToTradeReq = (
  tradeMainForm: Partial<TradeMainDetails>,
  tradePrice: Partial<TradePricingDetails>,
  tradeAditionals: Partial<TradeAditionalsDetails>
): any => {
  const price: TradePriceRequest = {
    id: tradePrice.id,
    expression: tradePrice.expression,
    precioUnitario: enumValueToKey(EnumPrecioUnitario, tradePrice.currencyAndUnit),
    redondeo: enumValueToKey(EnumRedondeo, tradePrice.rounding),
    priceCalculationType:
      typeof tradePrice.priceCalculationType === 'string'
        ? enumValueToKey(EnumPriceCalculationType, tradePrice.priceCalculationType)
        : tradePrice.priceCalculationType,
    version: tradePrice.version
  }
  let trade: any = {
    id: tradeMainForm.id,
    descripcion: tradeMainForm.description,
    validacion: enumValueToKey(EnumTipoValidacion, tradeMainForm.state),
    comentarios: tradeAditionals.comments ? tradeAditionals.comments : null,
    divisa: { id: tradeMainForm.currency },
    tradeType: { id: tradeAditionals.category },
    libro: tradeAditionals.book ? tradeAditionals.book : null,
    fechaInicio: moment(tradeMainForm.initDate).format('YYYY-MM-DD'),
    fechaFin: moment(tradeMainForm.endDate).format('YYYY-MM-DD'),
    fechaFirma: moment(tradeMainForm.signDate).format('YYYY-MM-DD'),
    contraparteId: tradeMainForm.counterpart,
    contratoId: tradeAditionals.contract ? tradeAditionals.contract : null,
    metodoPagoId: tradeAditionals.paymentMethod ? tradeAditionals.paymentMethod : null,
    cicloFacturacionId: tradeAditionals.billingCycleId ? tradeAditionals.billingCycleId : null,
    nivelFacturacion: tradeAditionals.billingLevel ? tradeAditionals.billingLevel : null,
    brokers: tradeAditionals.brokers ? tradeAditionals.brokers : null,
    broker: tradeAditionals.broker ? tradeAditionals.broker : null,

    posicionesDelta: [
      {
        id: tradeMainForm.positionId,
        codPosicion: tradeMainForm.positionCode,
        fechaInicio: moment(tradeMainForm.initDate).format('YYYY-MM-DD'),
        fechaFin: moment(tradeMainForm.endDate).format('YYYY-MM-DD'),
        tipoPosicion: enumKeyToValue(EnumTipoPosicion, tradeMainForm.type),
        unidadMedida: tradeMainForm.dailyQuantityUnit,
        cantidadTotal: tradeMainForm.totalQuantity,
        zonaBalance: enumKeyToValue(EnumZonaBalance, tradeMainForm.balanceZone),
        puntoEntregaDelta: { id: tradeMainForm.deliveryPoint },
        tramosDelta: [
          {
            idTramo: tradeMainForm.tractId,
            fee: tradeMainForm.fee,
            cantidadDiaria: tradeMainForm.dailyQuantity,
            fechaInicio: moment(tradeMainForm.initDate).format('YYYY-MM-DD'),
            fechaFin: moment(tradeMainForm.endDate).format('YYYY-MM-DD')
          }
        ]
      }
    ]
  }

  if (price.id) {
    trade = { ...trade, posicionesDelta: [{ ...trade.posicionesDelta[0], price: price }] }
  }

  if (trade.tradeType.id === null) {
    trade = { ...trade, tradeType: null }
  }

  return trade
}

export const mapFormsToTradeDetails = (
  tradeMainForm: Partial<TradeMainDetails>,
  tradePrice: Partial<TradePricingDetails>,
  tradeAditionals: Partial<TradeAditionalsDetails>,
  positions: NewPosicionPrecio[]
): TradeDetailsRequest => {
  const price: TradePriceRequest = {
    id: tradePrice.id,
    expression: tradePrice.expression,
    precioUnitario: enumValueToKey(EnumPrecioUnitario, tradePrice.currencyAndUnit),
    redondeo: enumValueToKey(EnumRedondeo, tradePrice.rounding),
    priceCalculationType:
      typeof tradePrice.priceCalculationType === 'string'
        ? enumValueToKey(EnumPriceCalculationType, tradePrice.priceCalculationType)
        : tradePrice.priceCalculationType,
    version: tradePrice.version
  }
  let trade: any = {
    id: tradeMainForm.id,
    descripcion: tradeMainForm.description,
    validacion: enumValueToKey(EnumTipoValidacion, tradeMainForm.state),
    comentarios: tradeAditionals.comments ? tradeAditionals.comments : null,
    divisa: { id: tradeMainForm.currency },
    tradeType: { id: tradeAditionals.category },
    libro: tradeAditionals.book ? tradeAditionals.book : null,
    fechaInicio: moment(tradeMainForm.initDate).format('YYYY-MM-DD'),
    fechaFin: moment(tradeMainForm.endDate).format('YYYY-MM-DD'),
    fechaFirma: moment(tradeMainForm.signDate).format('YYYY-MM-DD'),
    contraparteId: tradeMainForm.counterpart,
    contratoId: tradeAditionals.contract ? tradeAditionals.contract : null,
    metodoPagoId: tradeAditionals.paymentMethod ? tradeAditionals.paymentMethod : null,
    cicloFacturacionId: tradeAditionals.billingCycleId ? tradeAditionals.billingCycleId : null,
    nivelFacturacion: tradeAditionals.billingLevel ? tradeAditionals.billingLevel : null,
    brokers: tradeAditionals.brokers ? tradeAditionals.brokers : null,
    broker: tradeAditionals.broker ? tradeAditionals.broker : null,

    posicionesDelta: positions.map(pos => {
      return {
        id: pos.idPosicion,
        codPosicion: tradeMainForm.positionCode,
        fechaInicio: moment(pos.fechaInicio).format('YYYY-MM-DD'),
        fechaFin: moment(pos.fechaFin).format('YYYY-MM-DD'),
        tipoPosicion: enumEnumToValueString(EnumTipoPosicion, pos.tipoPosicion),
        unidadMedida: pos.unidadMedida,
        cantidadTotal: pos.cantidadTotal,
        zonaBalance: enumKeyToValue(EnumZonaBalance, pos.zonaBalance),
        puntoEntregaDelta: { id: pos.puntoEntrega ? pos.puntoEntrega.id : null },
        tramosDelta: pos.tramos
          ? pos.tramos.map(tract => {
              return {
                idTramo: tract.idTramo,
                fee: tract.fee,
                cantidadDiaria: tract.cantidadDiaria,
                fechaInicio: moment(tract.fechaInicio).format('YYYY-MM-DD'),
                fechaFin: moment(tract.fechaFin).format('YYYY-MM-DD')
              }
            })
          : []
      }
    })
  }

  if (price.id && positions.length === 1) {
    trade = { ...trade, posicionesDelta: [{ ...trade.posicionesDelta[0], price: price }] }
  }

  if (trade.tradeType.id === null) {
    trade = { ...trade, tradeType: null }
  }

  return trade
}

export const convertDiffToModel = (obj: Partial<TradeDetailsRequest>) => {
  let o = obj
  if (obj.posicionesDelta) {
    o.posicionesDelta = Object.values(obj.posicionesDelta)
    o.posicionesDelta.map(poss => {
      if (poss.tramosDelta) {
        poss.tramosDelta = Object.values(poss.tramosDelta)
      }
    })
  }
  return o
}

export const mapToAPIRequest = (
  patchObject,
  originalTrade: any,
  tradeResponse: any
): Partial<PatchTradePioneerRequest> | null => {
  let requestObj
  if (patchObject) {
    requestObj = { trade: patchObject }
    if (
      patchObject.contratoId !== undefined &&
      patchObject.contratoId != tradeResponse.contractId
    ) {
      requestObj.trade = {
        ...requestObj.trade,
        conceptoId:
          patchObject.contratoId === null
            ? undefined
            : tradeResponse?.conceptId
              ? tradeResponse.conceptId
              : tradeResponse?.positions[0]?.idConcepto,
        startDate: tradeResponse.initDate,
        endDate: tradeResponse.endDate
      }
    }
    if (requestObj.trade?.metodoPagoId !== undefined) {
      delete requestObj.trade.metodoPagoId
    }
    if (requestObj.trade?.cicloFacturacionId === null) {
      delete requestObj.trade.cicloFacturacionId
    }
    if (
      requestObj.trade?.cicloFacturacionId !== undefined &&
      patchObject.contratoId === undefined
    ) {
      requestObj.trade = {
        ...requestObj.trade,
        contratoId: tradeResponse.contractId,
        conceptoId:
          patchObject.contratoId === null
            ? undefined
            : tradeResponse?.conceptId
              ? tradeResponse.conceptId
              : tradeResponse?.positions[0]?.idConcepto,
        startDate: tradeResponse.initDate,
        endDate: tradeResponse.endDate
      }
    }
    // if (requestObj.trade?.nivelFacturacion !== undefined) {
    //   delete requestObj.trade.nivelFacturacion
    // }
    // Es necesario incluir tanto tradeType como tipoTrade a null para el patch de tradeDeepUpdate.
    if (patchObject.tradeType === null) {
      requestObj.trade = { ...requestObj.trade, tipoTrade: null }
    }
    if (patchObject.brokers !== undefined) {
      patchObject.brokers.forEach(b => {
        if (b.subjectId === null && b.commissionId === null && b.commercialId) {
          // DELETE
          if (requestObj.delete === undefined) {
            requestObj = { ...requestObj, delete: {} }
            if (requestObj.delete.brokerIds === undefined) {
              requestObj.delete.brokerIds = []
            }
          }
          requestObj.delete.brokerIds = [...requestObj.delete.brokerIds, b.commercialId]
        } else {
          requestObj = { ...requestObj, trade: { ...(requestObj.trade || null) } }
          if (requestObj.trade?.brokerIds === undefined) {
            requestObj.trade.brokerIds = []
          }
          if (b.commercialId) {
            // UPDATE
            if (b.subjectId) {
              requestObj.trade.brokerIds = [
                ...requestObj.trade.brokerIds,
                {
                  commercialId: b.commercialId,
                  commercialSubjectId: b.subjectId ? b.subjectId : null,
                  productId: b.commissionId ? b.commissionId : null
                }
              ]
            }
          } else {
            // CREATE
            if (b.subjectId && b.commissionId) {
              requestObj.trade.brokerIds = [
                ...requestObj.trade.brokerIds,
                {
                  // en caso de que la contraparte se esté modificando también, sino utilizamos la del trade
                  counterpartId: patchObject?.counterpartId
                    ? patchObject.counterpartId
                    : originalTrade.contraparteId,
                  commercialSubjectId: b.subjectId,
                  productId: b.commissionId
                }
              ]
            }
          }
        }
      })

      requestObj.trade?.brokers && delete requestObj.trade.brokers
      requestObj.trade?.broker && delete requestObj.trade.broker
    }
    // if (patchObject.contractId === null) {
    //   requestObj = { ...requestObj, delete: { }}
    // }
  } else {
    return null
  }
  return requestObj
}

// function convertStrObj(obj) {
//   const res = {}
//   for (const key in obj) {
//     res[key] = {};
//     for (const prop in obj[key]) {
//       const parsed = String(obj[key][prop]);
//       res[key][prop] = parsed === '' ? obj[key][prop] : parsed;
//     }
//   }
//   return res;
// }

function convertStrObj(o) {
  Object.keys(o).forEach(k => {
    // if (typeof o[k] === 'object' && o[k] !== null && o[k] !== undefined) {
    //   return toString(o[k]);
    // }
    if (o[k] === null || o[k] === undefined) {
      return o[k]
    } else {
      o[k] = '' + o[k]
    }
  })

  return o
}

export const mapToOdataRequestSimple = (
  request: Partial<any>,
  originalTrade: TradeDetailsRequest
): any => {
  if (request?.trade && request.trade?.nivelFacturacion) {
    request.trade.nivelFacturacion = `${request.trade.nivelFacturacion}`
  }
  if (request.trade == null) return request
  if (request.trade.posicionesDelta === null || request.trade.posicionesDelta === undefined) {
    return request
  } else if (request.trade.posicionesDelta) {
    const possId = originalTrade.posicionesDelta[0] && originalTrade.posicionesDelta[0].id
    const tractId =
      originalTrade.posicionesDelta[0] &&
      originalTrade?.posicionesDelta[0]?.tramosDelta &&
      originalTrade?.posicionesDelta[0]?.tramosDelta[0] &&
      originalTrade.posicionesDelta[0].tramosDelta[0].idTramo
    const positions = request.trade.posicionesDelta.map(pos => {
      let poss: any = pos
      if (poss?.tramosDelta) {
        const tracts = poss.tramosDelta?.map(t => {
          if (t?.fee === '') {
            t.fee = null
          }
          return { ...t, id: `Tramos(${tractId})` }
        })
        poss = { ...poss, tramosDelta: tracts, id: `Posiciones(${possId})` }
      }
      if (pos.unidadMedida) {
        poss = { ...poss, unidadMedida: String(pos.unidadMedida) }
      }
      if (pos.price) {
        // we need to parse price props to strings due to OData Pricing API request. It would accept "Simple" or "2" but no integer.
        const parsedPrice = convertStrObj(pos.price)
        poss = {
          ...poss,
          price: { ...parsedPrice, id: originalTrade.posicionesDelta[0].price?.id }
        }
      }
      if (pos.puntoEntregaDelta) {
        poss = {
          ...poss,
          id: `Posiciones(${possId})`,
          codPosicion: originalTrade.posicionesDelta[0].codPosicion,
          puntoEntregaDelta: { id: `elementoslogisticos(${pos.puntoEntregaDelta.id})` }
        }
      }
      return { ...poss, id: `Posiciones(${possId})` }
    })
    return { ...request, trade: { ...request.trade, posicionesDelta: positions } }
  }
  return request
}

// export const mapFormsToTradeResponse = (tradeMainForm: Partial<TradeMainDetails>, tradePrice: Partial<TradePricingDetails>, tradeAditionals: Partial<TradeAditionalsDetails>): Partial<TradeDetailsRequest> => {
//   // balanceZone: trade?.positions[0].zonaBalance ? enumValueToKey(EnumZonaBalance, trade?.positions[0].zonaBalance) : undefined,
//   //   deliveryPointId: trade?.positions[0].puntoEntrega.id,
//   //     // deliveryPoint: trade?.positions[0].PuntoEntrega,

//   //     totalQuantity: trade?.positions[0].tramos[0].cantidadTotal,
//   //       dailyQuantity: trade?.positions[0].tramos[0].cantidadDiaria,
//   // fee: trade?.positions[0]?.tramos[0]?.fee

//   const positions: Partial<Position>[] = [
//     {
//       zonaBalance: tradeMainForm.balanceZone,
//       // puntoEntrega: tradeMainForm.deliveryPoint,
//       tramos: [{
//         fee: tradeMainForm.fee,
//         cantidadTotal: tradeMainForm.totalQuantity,
//         cantidadDiaria: tradeMainForm.dailyQuantity
//       }],
//       price: {
//         expression: tradePrice.expression,
//         priceCalculationType: tradePrice.priceCalculationType,
//         precioUnitario: tradePrice.currencyAndUnit,
//         redondeo: tradePrice.rounding,
//         version: tradePrice.version
//       }
//     }
//   ]

//   const trade: Partial<TradeDetailsResponse> = {
//     tradeId: tradeMainForm.id,
//     code: tradeMainForm.code,
//     description: tradeMainForm.description,
//     type: tradeMainForm.type,
//     state: enumValueToKey(EnumTipoValidacion, tradeMainForm.state),
//     currency: tradeMainForm.currency,
//     initDate: tradeMainForm.initDate,
//     endDate: tradeMainForm.endDate,
//     signDate: tradeMainForm.signDate,
//     // company: tradeMainForm.
//     counterpartId: tradeMainForm.counterpart,

//     // Aditionals
//     categoryId: tradeAditionals.category,
//     book: tradeAditionals.book,
//     contractId: tradeAditionals.contract,
//     paymentMethodType: enumKeyToValue(EnumTipoMetodoPago, tradeAditionals.paymentMethod),
//     billingCycle: tradeAditionals.billingCycle,
//     billingLevel: tradeAditionals.billingLevel,
//     broker: tradeAditionals.broker,
//     comments: tradeAditionals.comments,

//     positions: positions
//   }

//   return trade;
// }

// export const mapRequestToTradeResponse = (tradeReq: Partial<TradeDetailsRequest>): Partial<TradeDetailsResponse> => {
//   const trade: Partial<TradeDetailsResponse> = {
//     description: tradeReq.descripcion,
//     state: enumValueToKey(EnumTipoValidacion, tradeReq.validacion),
//     comments: tradeReq.comentarios,
//     currency: tradeReq.divisa?.id,
//     categoryId: tradeReq.tradeType,
//     initDate: tradeReq.fechaInicio,
//     endDate: tradeReq.fechaFin,
//     signDate: tradeReq.fechaFirma
//   }

//   return trade;
// }

export const extractDistinctLogisticElements = (
  trades: TradeListItemViewModel[]
): SelectOption[] => {
  const logisticElements = getUniqueArrayByProperty(
    trades
      .flatMap(x => x.deliveryPoints || [])
      .map((x: LogisticElementBase) => ({
        label: x.description || 'Default Description',
        value: x.id
      })),
    'value'
  )
  return [
    ...logisticElements,
    { label: i18n.t(`enums:EnumTipoPosicion.Multiposition`), value: 9999 }
  ]
}

export const invoiceCyclesMapperToDropDown = (items: CicloFacturacion[]): SelectOption[] => {
  return items && items.map(invoiceCycleMapperToDropDown)
}

export const invoiceCycleMapperToDropDown = (item: CicloFacturacion): SelectOption => {
  return (
    item && {
      value: item.idCicloFacturacion,
      label: item.descripcion || ''
    }
  )
}

export const currenciesMapperToDropDown = (items: Currency[]): SelectOption[] => {
  return items && items.map(currencyMapperToDropDown)
}

export const currencyMapperToDropDown = (item: Currency): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.codCurrency || ''
    }
  )
}

export const measureUnitsMapperToDropDown = (items: MeasureUnit[]): SelectOption[] => {
  return items && items.map(measureUnitMapperToDropDown)
}

export const measureUnitMapperToDropDown = (item: MeasureUnit): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.descMeasureUnit || ''
    }
  )
}

export const balanceZonesMapperToDropDown = (items: BalanceZoneStoreModel[]): SelectOption[] => {
  return items && items.map(balanceZoneMapperToDropDown)
}

export const balanceZoneMapperToDropDown = (item: BalanceZoneStoreModel): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.description || item.code || ''
    }
  )
}

export const sortTradesByDateAndTime = (valuesArray: TradeListItemViewModel[] | undefined = []) => {
  const sortedArray = valuesArray.sort((a, b) => {
    if (moment(a.signDate).isSame(moment(b.signDate), 'days')) {
      return moment(a.initDate).isBefore(moment(b.initDate)) ? 1 : -1
    } else {
      return moment(a.signDate).isBefore(moment(b.signDate), 'days') ? 1 : -1
    }
  })
  return sortedArray
}

export const formatPositionsForTable = (positions: PosicionPrecio[], deliveryPoints) => {
  return positions.map(position => {
    const price = position.price
    const positionPrice: NewPricePosition | null =
      price && price.expression && price.priceCalculationType && price.priceUnit && price.rounding
        ? {
            expression: price.expression,
            priceCalculationType: price.priceCalculationType,
            rounding: price.rounding,
            priceUnit: price.priceUnit,
            version: price?.version ? price.version : 1
          }
        : null
    // const formatDeliveryPoint = deliveryPoints.find(
    //   deliveryPoint => deliveryPoint.value === position.deliveryPoint.id
    // );
    const formatPositionType = enumEnumToValueNumber(EnumTipoPosicion, position.tipoPosicion)
    return formatDataForPositionTable(
      { ...position, tipoPosicion: formatPositionType },
      deliveryPoints,
      positionPrice,
      position?.codPosicion,
      position?.tramos
    )
  })
}

export const formatDataForPositionTable = (
  formData,
  deliveryPoints,
  price: NewPricePosition | null,
  codPosicion?: string,
  tractsList?: Partial<Tramo>[]
): PosicionPrecio => {
  const position = enumToSelectOptionArrayDefaultValues(PositionType, 'enums:PositionType', [
    PositionType.Sale,
    PositionType.Purchase
  ])
  const formatPosition = position.find(pos => pos.value === formData.tipoPosicion)
  const formatDeliveryPoint = deliveryPoints.find(
    deliveryPoint =>
      deliveryPoint.value === formData.deliveryPoint ||
      deliveryPoint.value === formData.puntoEntrega?.id ||
      deliveryPoint.value === formData.puntoEntregaId
  )
  const puntoEntregaId =
    formData?.puntoEntregaId || formData.puntoEntrega?.id || formatDeliveryPoint?.value

  const priceDates = getNewPriceDates(
    { newPositionStartDate: formData.fechaInicio, newPositionEndDate: formData.fechaFin },
    tractsList as Tramo[]
  )

  return {
    ...formData,
    codPosicion,
    tipoPosicion: formatPosition?.label,
    puntoEntrega: {
      id: puntoEntregaId,
      descripcion:
        formData?.puntoEntrega && formData.puntoEntrega?.descripcion
          ? formData.puntoEntrega.descripcion
          : formatDeliveryPoint?.label
    },
    price: price
      ? {
          priceCalculationType: price.priceCalculationType,
          expression: price.expression,
          priceUnit: price.priceUnit,
          rounding: price.rounding,
          version: price.version,
          startDate: priceDates.priceStartDate,
          endDate: priceDates.priceEndDate
        }
      : null,
    tramos: tractsList
  }
}

export const mapPriceToPrecioRequest = (
  price: Partial<PricePosition>
): Partial<PrecioPosicionRequest> => {
  return {
    id: price.id,
    expression: price.expression,
    priceCalculationType: enumEnumToValueString(
      EnumPriceCalculationType,
      price.priceCalculationType
    ),
    redondeo: enumEnumToValueString(EnumRedondeo, price.rounding),
    precioUnitario: enumEnumToValueString(EnumPrecioUnitario, price.priceUnit),
    startDate: price.startDate ? moment(price.startDate).format('YYYY-MM-DD') : undefined,
    endDate: price.endDate ? moment(price.endDate).format('YYYY-MM-DD') : undefined
  }
}

export const mapPositionToForm = (position: NewPosicionPrecio): NewPosicionPrecio => {
  const measureUnitId = enumEnumToValueNumber(EnumUnidadMedida, position.unidadMedida)
  const balanceZoneId = enumEnumToValueNumber(EnumZonaBalance, position.zonaBalance)
  const positionType = enumEnumToValueNumber(EnumTipoPosicion, position.tipoPosicion)
  return {
    ...position,
    unidadMedida: measureUnitId ? measureUnitId : position.unidadMedida,
    zonaBalance: balanceZoneId ? balanceZoneId : position.zonaBalance,
    tipoPosicion: positionType ? positionType : position.tipoPosicion
  }
}

export const mapPositionSimpleToForm = (position: NewPosicionPrecio): NewPosicionPrecio => {
  const measureUnitId = enumEnumToValueNumber(EnumUnidadMedida, position.unidadMedida)
  const balanceZoneId = enumEnumToValueNumber(EnumZonaBalance, position.zonaBalance)
  const positionType = enumEnumToValueNumber(EnumTipoPosicion, position.tipoPosicion)
  const cantidadDiaria =
    position.tramos && position.tramos.length === 1 ? position.tramos[0].cantidadDiaria : 0
  const fee = position.tramos && position.tramos.length === 1 ? position.tramos[0]?.fee : 0

  return {
    ...position,
    unidadMedida: measureUnitId ? measureUnitId : position.unidadMedida,
    zonaBalance: balanceZoneId ? balanceZoneId : position.zonaBalance,
    tipoPosicion: positionType ? positionType : position.tipoPosicion,
    cantidadDiaria: cantidadDiaria,
    fee: fee,
    puntoEntregaId: position.puntoEntrega.id
  }
}

export const mapSimplePositionTableToMainForm = (
  position: NewPosicionPrecio
): PositionMainDetails => {
  let dailyQuantity = 0
  if (position.tramos && position.tramos.length === 1) {
    dailyQuantity = position.tramos[0].cantidadDiaria ? position.tramos[0].cantidadDiaria : 0
  }
  return (
    position && {
      initDate: position.fechaInicio,
      endDate: position.fechaFin,
      type: position.tipoPosicion
        ? enumEnumToValueNumber(EnumTipoPosicion, position.tipoPosicion)
        : undefined,
      balanceZone: position.zonaBalance
        ? enumEnumToValueNumber(EnumZonaBalance, position.zonaBalance)
        : undefined,
      dailyQuantity: dailyQuantity,
      totalQuantity: position.cantidadTotal,
      deliveryPoint: position.puntoEntrega.id,
      dailyQuantityUnit: position.unidadMedida
        ? enumEnumToValueNumber(EnumUnidadMedida, position.unidadMedida)
        : undefined,
      fee: position.fee
    }
  )
}

export const checkPositionSimpleComplete = (trade: Partial<TradeMainDetails>): boolean => {
  return trade &&
    trade.initDate &&
    trade.endDate &&
    trade.type &&
    trade.balanceZone &&
    trade.dailyQuantity &&
    trade.totalQuantity &&
    trade.deliveryPoint &&
    trade.dailyQuantityUnit
    ? true
    : false
}

export const mapCreatePositionRequest = (position: NewPosicionPrecio): PatchTradePioneerRequest => {
  const newPrice: any | undefined =
    position.price &&
    position.price.expression &&
    position.price.rounding &&
    position.price.priceUnit &&
    position.price.priceCalculationType
      ? {
          redondeo: enumEnumToValueString(EnumRedondeo, position.price.rounding) ?? '',
          priceCalculationType:
            enumEnumToValueString(EnumPriceCalculationType, position.price.priceCalculationType) ??
            '',
          precioUnitario: enumEnumToValueString(EnumPrecioUnitario, position.price.priceUnit) ?? '',
          expression: position.price?.expression,
          version: position.price?.version ? position.price?.version : 1,
          startDate: position.price.startDate
            ? position.price.startDate
            : moment(position.fechaInicio).format('YYYY-MM-DD'),
          endDate: position.price.endDate
            ? position.price.endDate
            : moment(position.fechaFin).format('YYYY-MM-DD')
        }
      : undefined

  const deliveryPointID = position.puntoEntrega ? position.puntoEntrega.id : null

  const tracts: TramosModelPatchPioneerRequest[] = position.tramos
    ? position.tramos.map(t => {
        const tract: TramosModelPatchPioneerRequest = {
          ...t,
          fechaInicio: moment(t.fechaInicio).format('YYYY-MM-DD'),
          fechaFin: moment(t.fechaFin).format('YYYY-MM-DD')
        }
        return tract
      })
    : []

  return {
    trade: {
      posicionesDelta: [
        {
          codPosicion: position.codPosicion,
          descripcion: position.descripcion,
          unidadMedida: enumEnumToValueString(EnumUnidadMedida, position.unidadMedida),
          zonaBalance: enumEnumToValueString(EnumZonaBalance, position.zonaBalance),
          fechaInicio: moment(position.fechaInicio).format('YYYY-MM-DD'),
          fechaFin: moment(position.fechaFin).format('YYYY-MM-DD'),
          tipoPosicion: position.tipoPosicion,
          puntoEntregaDelta: {
            id: `elementoslogisticos(${deliveryPointID})`
          },
          tramosDelta: tracts,
          price: newPrice
        }
      ]
    }
  }
}

export const mapEditPositionRequest = (
  positionID: number,
  modifiedProps: Partial<PosicionPrecioDiff>
): PatchTradePioneerRequest => {
  const trade = getActiveTrade()
  const position =
    trade && trade.positions && trade.positions.find(p => p.idPosicion === positionID)
  let tramos: Partial<Tramo>[] = []
  if (modifiedProps.tramos) {
    tramos = [...modifiedProps.tramos]
  }

  if (position === null) return {}
  let deltaProps: Partial<PosicionDelta> | null = null
  let request
  if (position && modifiedProps) {
    if (modifiedProps.puntoEntrega) {
      deltaProps = {
        puntoEntregaDelta: { id: `elementosLogisticos(${modifiedProps.puntoEntrega.id})` }
      }

      delete modifiedProps.puntoEntrega
    }

    modifiedProps.tramos && delete modifiedProps.tramos
    if (modifiedProps.price) {
      const priceID = position.price ? position.price.id : null
      const modPrice = mapPriceToPrecioRequest(modifiedProps.price)
      if (priceID) {
        deltaProps = { ...deltaProps, price: { ...modPrice, id: priceID } }
      }

      delete modifiedProps.price
    }

    let positionRequest: Partial<PosicionDelta> = {
      id: `Posiciones(${position.idPosicion})`,
      ...modifiedProps,
      ...deltaProps
    }

    if (tramos.length > 0) {
      positionRequest = { ...positionRequest, tramosDelta: tramos }
    }

    request = position
      ? {
          trade: {
            posicionesDelta: [positionRequest]
          }
        }
      : {}
  }

  return request
}

export const diffPositionMapper = (
  modifiedPosition: Partial<NewPosicionPrecio>
): Partial<PosicionPrecioDiff> => {
  const trade = getActiveTrade()
  const position =
    trade &&
    trade.positions &&
    trade.positions.find(p => p.idPosicion === modifiedPosition.idPosicion)

  const modPrice =
    modifiedPosition && modifiedPosition.price
      ? {
          ...modifiedPosition.price,
          priceCalculationType: enumEnumToValueString(
            EnumPriceCalculationType,
            modifiedPosition.price.priceCalculationType
          )
        }
      : null

  let priceDiff: Partial<PricePosition> =
    position && position.price && modPrice ? updatedDiff(position.price, modPrice) : {}

  let formattedModifiedPosition = {
    ...modifiedPosition,
    price: modPrice,
    tipoPosicion: modifiedPosition.tipoPosicion
      ? enumEnumToValueString(EnumTipoPosicion, modifiedPosition.tipoPosicion)
      : 0,
    unidadMedida: modifiedPosition.unidadMedida
      ? enumEnumToValueString(EnumUnidadMedida, modifiedPosition.unidadMedida)
      : 0,
    zonaBalance: modifiedPosition.zonaBalance
      ? enumEnumToValueString(EnumZonaBalance, modifiedPosition.zonaBalance)
      : 0
  }

  formattedModifiedPosition.cantidadTotal && delete formattedModifiedPosition.cantidadTotal
  formattedModifiedPosition.cantidadDiaria && delete formattedModifiedPosition.cantidadDiaria
  formattedModifiedPosition.fee && delete formattedModifiedPosition.fee

  let positionDiff: Partial<PosicionPrecioDiff> = position
    ? updatedDiff(position, formattedModifiedPosition)
    : {}
  const tractsDiff = diffTractMapper(modifiedPosition, position)
  if (tractsDiff && tractsDiff.length > 0) {
    positionDiff = { ...positionDiff, tramos: tractsDiff }
  }
  if (!isEmpty(priceDiff)) {
    positionDiff = { ...positionDiff, price: priceDiff }
  }

  return positionDiff
}

export const diffTractMapper = (
  modifiedTract: Partial<NewPosicionPrecio>,
  originalPosition: PosicionPrecio | undefined
): Partial<TramosDelta>[] | null => {
  let tractsDiff: Partial<TramosDelta>[] = []
  const deletedTracts = originalPosition?.tramos
    ? differenceBy(originalPosition?.tramos, modifiedTract?.tramos ?? [], 'idTramo')
    : []
  modifiedTract?.tramos?.forEach((tramo, idx) => {
    if (!tramo.idTramo) {
      tractsDiff.push(tramo)
    } else if (!originalPosition?.tramos.includes(tramo)) {
      tractsDiff.push({
        id: `Tramos(${tramo.idTramo})`,
        cantidadDiaria: tramo.cantidadDiaria,
        fee: tramo.fee,
        fechaInicio: tramo.fechaInicio,
        fechaFin: tramo.fechaFin
      })
    }
  })
  deletedTracts.forEach((tramo, idx) => {
    if (tramo.idTramo) {
      tractsDiff.push({
        id: `Tramos(${tramo.idTramo})`,
        removed: { reason: 'deleted' }
      })
    }
  })
  return tractsDiff
}

export const mapDeletePositionRequest = (positionID: number): PatchTradePioneerRequest => {
  return {
    trade: {
      posicionesDelta: [
        {
          id: `Posiciones(${positionID})`,
          removed: { reason: 'deleted' }
        }
      ]
    }
  }
}

export const mapAddTradeFromMassiveBSOpsRequest = (
  data: AddMassiveBuyAndSellModel,
  companyId: number,
  balanceZone: number,
  opType: any
): AddTradeAPIRequest => {

  return {
      description: '',
      currency: EnumCurrency.EUR,
      initDate: moment(data.startDate).format('YYYY-MM-DD'),
      endDate: moment(data.endDate).format('YYYY-MM-DD'),
      signDate: moment().format('YYYY-MM-DD'),
      state: ValidationType.Validated,
      company: companyId,
      counterpart: data.counterpart.id,
      commodity: 1,      
      category: data.operationType.id == EnumTipoOperacion.Compra ? EnumTipoTrade.Compra : EnumTipoTrade.Venta,
      positions: [
        {
          deliveryPointId: data.logisticElement.description ? parseInt(data.logisticElement.description) : 0,
          positionType: enumKeyToValue(EnumTipoPosicion, data.operationType.id),
          measureUnit: EnumUnidadMedida.Kwh,
          balanceZone: enumKeyToValue(EnumZonaBalance, balanceZone),
          startDate: moment(data.startDate).format('YYYY-MM-DD'),
          endDate: moment(data.endDate).format('YYYY-MM-DD'),
          tracts: [
            {
              startDate: moment(data.startDate).format('YYYY-MM-DD'),
              endDate: moment(data.endDate).format('YYYY-MM-DD'),
              dailyQuantity: data.quantity
            }
          ]
        }
      ]
    }
  }